class BaseError extends Error {
  constructor(message?: string) {
    super(message)
    this.name = new.target.name
  }
}

export class NetworkUnauthorizedError extends BaseError {}

export class UnknownNetworkError extends BaseError {}

export class SerializeFailureError extends BaseError {
  constructor(message = "Cannot serialize object.") {
    super(message)
  }
}

export class UnknownError extends BaseError {}
